import React from 'react';
import { array, func } from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import SystemTableRowMenu from './SystemTableRowMenu';

import classes from './SystemsTable.module.css';

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: '#f4f4f4',
        }
    }
}))(TableRow);

const SystemsTable = ({
    filterBy,
    isFullArchitectAllowed,
    onSort,
    onToggleDeleteSystemEntityModal,
    order,
    orderBy,
    showContextMenu,
    systems,
    ...props
}) => {
    const isSortedByName = orderBy === 'name';
    const sortDirection = isSortedByName ? order : false;

    return (
        <Table className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell
                        className={classes.headerCell}
                        sortDirection={sortDirection}
                        onClick={onSort('name')}
                    >
                        <Tooltip
                            title={
                                <span className={classes.tooltip}>
                                    Sort
                                </span>
                            }
                            placement="top-start"
                        >
                            <TableSortLabel
                                active={isSortedByName}
                                direction={order}
                            >
                                Name
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>
                    <TableCell className={classes.headerCell}>
                        Type
                    </TableCell>
                    <TableCell padding="none" />
                </TableRow>
            </TableHead>
            <TableBody>
                {systems.map(item =>
                    <StyledTableRow key={item.id}>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {item.name}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{item.name}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {item.systemType.name}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{item.systemType.name}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell
                            className={classes.rowMenuCell}
                            padding="none"
                        >
                            <SystemTableRowMenu
                                system={item}
                                hidden={!isFullArchitectAllowed || !showContextMenu}
                                filterBy={filterBy}
                                onToggleDeleteSystemEntityModal={onToggleDeleteSystemEntityModal}
                            />
                        </TableCell>
                    </StyledTableRow>
                )}
            </TableBody>
        </Table>
    );
};

SystemsTable.defaultProps = {
    onSort:                          () => {},
    onToggleDeleteSystemEntityModal: () => {},
    systems:                         []
};

SystemsTable.propTypes = {
    systems:                         array.isRequired,
    onSort:                          func,
    onToggleDeleteSystemEntityModal: func
};

export default SystemsTable;
